var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArr3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29C31.7614 1 34 3.23858 34 6V20H6C3.23858 20 1 17.7614 1 15V1Z",
    stroke: "#E85446",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8828 10.936L10.1628 15L10.1628 13.128L14.3388 10.536L10.1628 8.008L10.1628 6.056L16.8828 10.056L16.8828 10.936Z",
    fill: "#E85446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8359 10.8801L18.1159 14.9441L18.1159 13.0721L22.2919 10.4801L18.1159 7.95209L18.1159 6.00009L24.8359 10.0001L24.8359 10.8801Z",
    fill: "#E85446"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr3);
export default __webpack_public_path__ + "static/media/arr3.93d7d51d9ca4ba2329826ba3cd6b1332.svg";
export { ForwardRef as ReactComponent };